import { InjectionContext } from './src/context';

const isTestBuild = (typeof BINGADS_TEST_BUILD !== 'undefined') && BINGADS_TEST_BUILD; // eslint-disable-line no-undef

export const globalContext = new InjectionContext({ disableDependencyCheck: isTestBuild || false });
export const uncheckedInjectionContext = new InjectionContext({ disableDependencyCheck: true });
